import { render } from "./editslot.vue?vue&type=template&id=2c2e9239"
import script from "./editslot.vue?vue&type=script&lang=js"
export * from "./editslot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__